/**
* AI写作-关键词
**/ 

<template>
    
  <div class="ai-title">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item >关键词库</el-breadcrumb-item>
      <!-- <el-breadcrumb-item v-if="detailShow">详情</el-breadcrumb-item> -->
    </el-breadcrumb>
    <el-card class="box-card">
      <!-- 标题列表 s -->
      <div class="box-table">

        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline"  :size="size" ref="ruleForm0">
          <el-form-item  >
            <el-input placeholder="关键词组" v-model="formInline.group" clearable> </el-input>
          </el-form-item>
          <el-form-item >
            <el-input placeholder="关键词" v-model="formInline.keywords" clearable> </el-input>
          </el-form-item>
          <el-form-item>
            <el-button :size="size"  icon="el-icon-search" @click="search">搜索</el-button>
            <!-- <el-button @click="resetForm('ruleForm0')" type="info" plain>重置</el-button> -->
            <el-button @click="addHandler" type="primary" plain>添加</el-button>
            <el-button @click="delHandler" type="danger" plain v-show="buttonShow">删除</el-button>
          </el-form-item>
        </el-form>

        <!--列表-->
        <el-table size="small" ref="multipleTable" tooltip-effect="dark" :data="listData" highlight-current-row 
        v-loading="loading" element-loading-text="拼命加载中" style="width: 100%;margin-top:20px"  
        @selection-change="handleSelectionChange">
           <el-table-column  type="selection" width="55"> </el-table-column>
          <el-table-column sortable  prop="id" label="编号" >
          </el-table-column>
          <el-table-column sortable prop="keywordGroup" label="关键词组" >
          </el-table-column>
          <el-table-column sortable prop="keywords" label="关键词" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template  slot-scope="scope">
              <el-button type="text" size="mini" @click="editHandler(scope.row)"><i class="el-icon-edit"></i></el-button>

            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination style="float:right" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

      </div>
      <!-- 标题列表 e -->
    </el-card>
    <!-- 添加关键词 -->
    <el-dialog
        :title="temp.id?'编辑关键词':'添加关键词'"
        :visible.sync="addDialogVisible"
        width="50%"
        :close-on-click-modal="false">
        <el-form  :model="temp" :rules="rules" ref="ruleForm">
            <el-form-item label="关键词组" prop="group">
                <el-input v-model="temp.group" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="关键词(一行一个)" prop="keywords">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 10}"
                    placeholder=""
                    v-model="temp.keywords">
                </el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addFun('ruleForm')">确 定</el-button>
        </span>
    </el-dialog>
    
  </div>
</template>

<script>
// 导入组件
import Pagination from '@/components/Pagination'
import moment from 'moment'
//实体类
import { addKeyword, modifyKeyword, delyKeyword, getKeyword} from '@/api/basisMG' 
// 导出模块
export default {
  // 模块名字
  name: "aiTitle",
  // 模块数据
  data() {
    //数据  
    return {
      addDialogVisible: false, //添加对话框显示
      detailDialogVisible: false, //详情对话框显示
      closeOnClickModal: false, //是否可以通过点击 modal 关闭 Dialog
      buttonShow: false,//操作按钮
      loading: false,
      size: 'small',
      formInline: {
        page: 1,
        pageSize: 10,
        group: '',
        keywords: '',
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      listData:[],
      temp: {
        id:null,
        group:"",
        keywords:""
      },
      rules: {
        group: [
            { required: true, message: '请输入关键词组', trigger: 'blur' }
          ],
          keywords: [
            { required: true, message: '请输入关键词', trigger: 'blur' }
          ],
        },
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    addFun(formName) {
      
      //提交词组
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.temp.id){
            addKeyword(this.temp).then(res=>{
              if(res.code===0){
                this.$message.success('添加成功')
                this.addDialogVisible = false
                this.search()
              }else{
                this.$message.error(res.message)
              }
            })
          }else{
            modifyKeyword(this.temp).then(res=>{
              if(res.code===0){
                this.$message.success('编辑成功')
                this.addDialogVisible = false
                this.search()
              }else{
                this.$message.error(res.message)
              }
            })
          }
        } else {
          return false;
        }
      });
      
      
    },
    
     // 获取列表
    getdata(parameter) {
      const params={
            group: parameter.group,
            keywords: parameter.keywords,
            page: parameter.page,
            pageSize: parameter.pageSize
        }
        getKeyword(params)
            .then(res => {
            this.loading = false
            if (res.success == false) {
                this.$message({
                type: 'info',
                message: res.message
                })
            } else {
                this.listData = res.data
                // 分页赋值
                this.pageparm.currentPage = this.formInline.page
                this.pageparm.pageSize = this.formInline.pageSize
                this.pageparm.total = res.totalCount
            }
        })
    },
    search(){
        this.getdata(this.formInline)
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    editHandler(row){
        this.temp.id = row.id
        this.temp.group = row.keywordGroup
        this.temp.keywords = row.keywords
        this.addDialogVisible=true
    },
    delHandler(){
        console.log(this.$refs.multipleTable.selection)
        let array = []
        if(this.$refs.multipleTable.selection.length>0){
          this.$refs.multipleTable.selection.forEach(e => {
            array.push(e.id)
          });
        }else{
          this.$message.warning('请选择操至少一条记录进行操作')
          return false
        }
        this.$confirm('确认删除吗？', '提示', {}).then(() => {
            
            const params = {
              ids:array
            }
            //支持批量删除
            delyKeyword(params).then(res=>{
              if(res.code===0){
                this.$message.success('删除成功')
                this.search()
              }else{
                this.$message.error(res.message)
              }
            })
        })
    },
    addHandler(){
        this.temp = {id:null, group: '', keywords:''}
        this.addDialogVisible=true
    },
    handleSelectionChange(){
      if(this.$refs.multipleTable.selection.length>0){
            this.buttonShow = true
        }else{
            this.buttonShow = false
        }
    }
  },
  filters: {
    timestampToTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:SS')
    },
    state(num) {
      switch (num) {
        case 0:
          return '生成中'
        case 1:
          return '已完成'
        case 2:
          return '失败'
        default:
          return ''
      }
    },
  },
  // 创建前状态(里面是操作)
  beforeCreate() {},
  // 创建完毕状态(里面是操作)
  created() {},
  // 挂载前状态(里面是操作)
  beforeMount() {},
  // 挂载结束状态(里面是操作)
  mounted() {
    this.getdata(this.formInline)
  },
  // 更新前状态(里面是操作)
  beforeUpdate() {},
  // 更新完成状态(里面是操作)
  updated() {},
  // 销毁前状态(里面是操作)
  beforeDestroy() {},
  // 销毁完成状态(里面是操作)
  destroyed() {}
};
</script>
// scoped 样式只在本组件使用
<style scoped>
/**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */
</style>



// WEBPACK FOOTER //
// src/views/ai/writer/keyword.vue